import React from 'react';

import { BookInfoList } from 'components';

import ProductShortInfo from '../product-short-info/ProductShortInfo';

import useStyles from './styles';

const ProductInfo = ({ product, initialSelectedCurrency }) => {
  const classes = useStyles();

  return (
    <div className={classes.wrapper}>
      <div className={classes.leftSide}>
        <ProductShortInfo
          item={product}
          titleClass={classes.title}
          isBedDetails={true}
        />
      </div>
      <div className={classes.rightSide}>
        <BookInfoList
          activity={product}
          isWithoutDescriptionForm={true}
          currency={initialSelectedCurrency}
          defaultExpanded={false}
          firstDefaultExpanded={true}
          isOverview={true}
        />
      </div>
    </div>
  );
};

export default ProductInfo;
